export const successActionCallback = (func) => ({
  callbacks: {
    success: func,
  },
});
